var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAccordioPsycho4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4987 0.583984V4.75065M11.4987 17.2507V21.4173M21.9154 11.0007H17.7487M5.2487 11.0007H1.08203M4.13307 3.63503L7.07891 6.58086M15.9185 15.4204L18.8643 18.3663M18.8643 3.63503L15.9185 6.58086M7.07891 15.4204L4.13411 18.3652",
    stroke: "#29292E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccordioPsycho4);
export default __webpack_public_path__ + "static/media/IconAccordioPsycho4.56405218b2c182a80bb8d2902d6efe2b.svg";
export { ForwardRef as ReactComponent };